import { createSlice } from "@reduxjs/toolkit";

export const subjectSlice = createSlice({
  name: "subject",
  initialState: {
    value: "DL_FRONT",
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = "DL_FRONT";
    },
  },
});

export const { update, reset } = subjectSlice.actions;

export default subjectSlice.reducer;
